import React from 'react';

export interface CardProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  statusBorder?: 'none' | 'normal' | 'due' | 'overdue' | 'blue';
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  action,
  children,
  footer,
  className = '',
  statusBorder = 'none',
  onClick,
}) => {
  const borderMap = {
    none: 'border-slate-200',
    normal: 'border-l-4 border-l-emerald-500 border-slate-200',
    due: 'border-l-4 border-l-amber-500 border-slate-200',
    overdue: 'border-l-4 border-l-rose-500 border-slate-200',
    blue: 'border-l-4 border-l-blue-500 border-slate-200',
  };

  const clickableStyles = onClick
    ? 'cursor-pointer hover:border-slate-300 hover:shadow-md active:scale-[0.99] transition-all'
    : '';

  return (
    <div
      onClick={onClick}
      className={`bg-white border rounded-xl shadow-xs overflow-hidden ${borderMap[statusBorder]} ${clickableStyles} ${className}`}
    >
      {(title || subtitle || action) && (
        <div className="px-4 py-3.5 sm:px-6 border-b border-slate-100 flex items-center justify-between gap-3">
          <div>
            {title && <h3 className="text-base sm:text-lg font-bold text-slate-900">{title}</h3>}
            {subtitle && <p className="text-xs sm:text-sm text-slate-500 mt-0.5">{subtitle}</p>}
          </div>
          {action && <div className="shrink-0">{action}</div>}
        </div>
      )}
      <div className="p-4 sm:p-6">{children}</div>
      {footer && (
        <div className="px-4 py-3 sm:px-6 bg-slate-50 border-t border-slate-100 text-sm text-slate-600">
          {footer}
        </div>
      )}
    </div>
  );
};
